import React, { Component, Fragment, MouseEvent } from 'react';
import { Trans } from 'react-i18next';
import { IconButton, Menu as MuiMenu, MenuItem } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';
import MoreHorzIcon from '@material-ui/icons/MoreHoriz';

interface IProps extends WithStyles<typeof styles> {
  sort: boolean;
  onSort: () => void;
}

interface IState {
  anchorEl: HTMLElement;
}

const styles = (theme: Theme) =>
  createStyles({
    button: {
      color: theme.palette.common.white,
      '&:hover': {
        color: theme.custom.palette.grey3,
      },
    },
  });

class FeedMenu extends Component<IProps, IState> {
  state: IState = {
    anchorEl: null,
  };

  handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleSort = () => {
    this.handleClose();
    this.props.onSort();
  };

  render() {
    const { classes, sort } = this.props;
    const { anchorEl } = this.state;

    return (
      <Fragment>
        <IconButton className={classes.button} onClick={this.handleClick}>
          <MoreHorzIcon />
        </IconButton>
        <MuiMenu anchorEl={anchorEl} open={!!anchorEl} onClose={this.handleClose}>
          <MenuItem selected={sort} disabled={sort} onClick={this.handleSort}>
            <Trans i18nKey="feed:menuTrending" />
          </MenuItem>
          <MenuItem selected={!sort} disabled={!sort} onClick={this.handleSort}>
            <Trans i18nKey="feed:menuChronologically" />
          </MenuItem>
        </MuiMenu>
      </Fragment>
    );
  }
}

export default withStyles(styles)(FeedMenu);
